import { Graphics, Sprite } from 'pixi.js';

export default class Card extends Sprite {
	constructor(card, deckSpriteSheet) {
		super();
		this.deckSpriteSheet = deckSpriteSheet;
		//if string change/parse to card
		if (typeof card === 'string') {
			const cardId = card;
			let cardRank = cardId[0];
			let cardSuit = cardId[1];
			let cardNumber = parseInt(cardRank);
			if (card.length === 3) {
				cardRank = cardId.substr(0, 2);
				cardSuit = card.substr(2, 1);
			}

			cardNumber = parseInt(cardRank);
			card = {
				id: cardId,
				deck: '',
				rank: cardRank,
				number: cardNumber,
				value: Math.min(cardNumber, 10),
				suit: cardSuit,
			};
		}

		this.id = card.id;
		this.rank = card.rank;
		this.suit = card.suit;
		this.number = card.number || card.rank;
		this.pile = card.pile || 'deck';
		this.showfront = card.showfront;
		this.dragging = false;
		this.data = null;
		this.meld = card.meld;
		this.randomId = Math.floor(Math.random() * 1000000);

		//this.card = card; //do i want each card to hold a reference to the card model or just update on onChange from base model?

		this.meldBar = new Graphics();
		this.meldBar.beginFill(0xFFFFFF);
		this.meldBar.drawRect(0, 0, 100, 10);
		this.meldBar.drawRoundedRect(0, 0, 100, 20, 5);
		// this.meldBar.alpha = 0.8;
		this.addChild(this.meldBar);

		// this.meldBar = new Graphics();
		// this.meldBar.lineStyle(2, 0x000000, 1);
		// //this.meldBar.beginFill(0xFFFFFF );
		// this.meldBar.position.set(0, 0);
		// this.meldBar.lineTo(100,0);
		// this.meldBar.quadraticCurveTo(100, 0, 0, 50);
		// this.addChild( this.meldBar);

		this.updateTexture();

		this.eventMode = 'static';
		this.buttonMode = true;
		this.anchor.set(0.5);
		//this.width = 115;
		//this.height = 161;
		//this.width = 150;
		//this.height = 210;
		//this.width = 50;
		//this.height = 150;

		//this.scale.set(0.6, 0.6);

		// this
		//     .on('pointerdown', this.onDragStart)
		//     .on('pointerup', this.onDragEnd)
		//     .on('pointerupoutside', this.onDragEnd)
		//     .on('pointermove', this.onDragMove);

		this.onChange = () => { };
	}

	updateTexture() {
		const deckSpriteSheet = this.deckSpriteSheet;

		if (this.showfront) {
			const textureCard = deckSpriteSheet.textures['CardBack.png'];
			if (textureCard) {
				this.texture = textureCard;
			}
		} else {
			let cardRank = this.number;
			if (this.number === 1) {
				cardRank = 'A';
			}

			if (this.number === 11) {
				cardRank = 'J';
			}

			if (this.number === 12) {
				cardRank = 'Q';
			}

			if (this.number === 13) {
				cardRank = 'K';
			}

			const cardSuit = this.suit.toUpperCase();

			const textureId = cardRank + cardSuit + '.png';
			const textureCard = deckSpriteSheet.textures[textureId];
			if (textureCard) {
				this.texture = textureCard;
			}
		}

		const meldColors = [0x479ACE, 0xC03500, 0x479ACE, 0xC03500, 0x479ACE, 0xC03500, 0x479ACE, 0xC03500];
		const meldBackgroundColors = [0xA2DAFF, 0xD7A7A7, 0xA2DAFF, 0xD7A7A7, 0xA2DAFF, 0xD7A7A7, 0xA2DAFF, 0xD7A7A7];
		if (this.meld) {
			if (this.texture) {
				const meldColor = meldColors[this.meld - 1];
				const meldBackgroundColor = meldBackgroundColors[this.meld - 1];
				this.meldBar.x = -this.texture.width / 2;
				this.meldBar.width = this.texture.width;
				this.meldBar.y = (this.texture.height / 2) - 20;
				this.meldBar.height = 20;
				this.meldBar.tint = meldColor;
				this.meldBar.visible = true;
				// this.tint = this.lightenColor(meldColor,10)//;0x9CCDED;
				this.tint = meldBackgroundColor;
			}
		}

		if (!this.meld) {
			this.meldBar.visible = false;
			this.tint = 0xFFFFFF;
			this.meldBar.tint = 0xFFFFFF;
		}
	}

	lightenColor(color, percent) {
		const num = parseInt(color, 16),
			amt = Math.round(2.55 * percent),
			R = (num >> 16) + amt,
			B = (num >> 8 & 0x00FF) + amt,
			G = (num & 0x0000FF) + amt;

		return (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
	};

	shadeColor(color, percent) {
		let R = parseInt(color.substring(1, 3), 16);
		let G = parseInt(color.substring(3, 5), 16);
		let B = parseInt(color.substring(5, 7), 16);

		R = parseInt(R * (100 + percent) / 100);
		G = parseInt(G * (100 + percent) / 100);
		B = parseInt(B * (100 + percent) / 100);

		R = (R < 255) ? R : 255;
		G = (G < 255) ? G : 255;
		B = (B < 255) ? B : 255;

		const RR = ((R.toString(16).length == 1) ? '0' + R.toString(16) : R.toString(16));
		const GG = ((G.toString(16).length == 1) ? '0' + G.toString(16) : G.toString(16));
		const BB = ((B.toString(16).length == 1) ? '0' + B.toString(16) : B.toString(16));

		return '0x' + RR + GG + BB;
	}

	randomTexture() {

		// var numbers = ["2","3","4","5","6","7","8","9","10","A","K","Q","J"];
		// var cardNumber =numbers[Math.floor(Math.random()*numbers.length)];
		// //var cardNumber = Math.floor(Math.random() * 9 + 1)+1;

		// var suits = ["C","D","H","S"];
		// var cardSuit = suits[Math.floor(Math.random()*suits.length)];

	}

	onDragStart(event) {
		// store a reference to the data
		// the reason for this is because of multitouch
		// we want to track the movement of this particular touch
		this.data = event.data;
		//this.alpha = 0.5;
		this.dragging = true;

		this.onChange();
	}

	onDragEnd() {
		this.alpha = 1;
		this.dragging = false;
		// set the interaction data to null
		this.data = null;
		this.onChange();
	}

	onDragMove() {
		if (this.dragging) {
			const newPosition = this.data.getLocalPosition(this.parent);
			this.x = newPosition.x;
			this.y = newPosition.y;
			this.onChange();
		}
	}

}
